import React from 'react';
import syles from './ButtonIcons.module.scss';

interface ButtonIconProps {
  typeIcons: 'close' | 'minimize' | 'restore';
  onClick: () => void;
}

const ButtonIcons: React.FC<ButtonIconProps> = ({ onClick, typeIcons }) => {
  return (
    <button
      data-testid={`btn-icons-${typeIcons}`}
      onClick={onClick}
      className={syles['button-icons__container']}
    >
      <img src={`assets/icons/${typeIcons}.png`} alt={typeIcons} />
    </button>
  );
};

export default ButtonIcons;
